// This page is for the initial load of the app.

/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { observer } from 'mobx-react';
import Grid from '@mui/material/Grid';

import ContentContainer from '../components/contentContainer';

import { useStyles } from './styles';

import useTranslator from '../../commons/translations';
import TranslationIds from '../../commons/translationIds';
import EcalLogo from '../../commons/images/EcalLogo';

function Loading (props) {
    const classes = useStyles();
    const {
        translate,
    } = useTranslator();

    return (
        <React.Fragment>
            <ContentContainer>
                <Grid>
                    <EcalLogo />
                </Grid>
                <Grid className={classes.text}>
                    {translate(TranslationIds.COMPONENT_LOADING)}...
                </Grid>
            </ContentContainer>           
        </React.Fragment>
    );
}

export default observer(Loading);